@if (form) {
  <div class="row">
    <div class="col-12">
      <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
        <span class="required">*</span>
      }</p>
      <div class="matrix-table">
        <div class="matrix-row matrix-head">
          <div class="matrix-row-label"></div>
          @for (sm of form.choices; track trackByIndex($index)) {
            <div class="matrix-col-label" [innerHTML]="sm.choice_name"></div>
          }
        </div>
        @for (row of rows; track trackByIndex($index)) {
          <div class="matrix-row">
            <div class="matrix-row-label" [innerHTML]="row.row_label"></div>
            @for (sm of form.choices; track trackByIndex($index)) {
              <div class="matrix-col-label" (click)="!isMulti && selectCell(row.matrix_row_id, sm.question_choice_id)">
                @if (!isMulti) {
                  <p-radiobutton [name]="row.matrix_row_id" [disabled]="form.view" [value]="sm.question_choice_id" [(ngModel)]="rowValues[row.matrix_row_id]"
                  (click)="$event.stopPropagation()"></p-radiobutton>
                }
                @if (isMulti) {
                  <p-checkbox [disabled]="form.view" [value]="sm.question_choice_id" [(ngModel)]="rowValuesMulti[row.matrix_row_id]"
                  (onChange)="onMultiChange()" (click)="$event.stopPropagation()"></p-checkbox>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
